import { Injectable } from '@angular/core';
import { ApiHttpService } from 'src/app/core/services/api-http.service';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { QueryStringParameters } from 'src/app/shared/classes/query-string-parameters';

@Injectable()
export class EnumService {
  constructor(private apiHttpService: ApiHttpService, private apiEndpointsService: ApiEndpointsService) {}

  public getEnumData(body: any) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('enum');
    return this.apiHttpService.post(url, body);
  }

  public createEnum(body: any) {
    const url: string = this.apiEndpointsService.createUrl('enum/create');
    return this.apiHttpService.post(url, body);
  }

  public getEnumById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('enum', [id]);
    return this.apiHttpService.get(url);
  }

  public updateEnumById(id: string, body: object) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('enum', [id]);
    return this.apiHttpService.put(url, body);
  }

  public deleteEnumById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('enum', [id]);
    return this.apiHttpService.delete(url);
  }
}
